import { CommonBindingDataService } from './../../services/common-binding-data.service';
import { UiService } from './../../services/ui.service';
import { UserCommonService } from './../../services/user-common.service';
import { StorageService } from './../../services/storage.service';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import { ToastMessageOptions } from 'primeng/api';
import { AppSettings } from '../../app.settings';

const OTP_TIMER_SECONDS = 15;

@Component({
  selector: 'app-otp-verifiy',
  templateUrl: './otp-verifiy.component.html',
  styleUrls: ['./otp-verifiy.component.scss']
})
export class OtpVerifiyComponent implements OnInit, OnDestroy {
  @Input() email;
  @Input() phone;

  @Output() otpPopClose: EventEmitter<any> = new EventEmitter();
  @Output() otpPopSave: EventEmitter<any> = new EventEmitter();

  msg: ToastMessageOptions[] = [];
  param = 'userType=admin';
  otpForm = new UntypedFormGroup({
    otpInput: new UntypedFormControl()
  });

  resendOTPDisable = true;
  timerSeconds = OTP_TIMER_SECONDS;
  private timerInterval: ReturnType<typeof setInterval> | null = null;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private storageService: StorageService,
    private commonServices: UserCommonService,
    private uiSerice: UiService,
    private commonBindingDataService: CommonBindingDataService,
  ) { }

  ngOnInit() {
    this.otpForm = this.formBuilder.group({
      otpInput: ['', [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(4),
        Validators.pattern(/^\d{4}$/)
      ]],
    });
    this.startTimer();
  }

  ngOnDestroy() {
    this.stopTimer();
  }

  get showResendLink(): boolean {
    return this.timerSeconds <= 0;
  }

  get timerDisplay(): string {
    const s = this.timerSeconds;
    return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
  }

  private startTimer(): void {
    this.timerSeconds = OTP_TIMER_SECONDS;
    this.resendOTPDisable = true;
    this.stopTimer();
    this.timerInterval = setInterval(() => {
      this.timerSeconds--;
      if (this.timerSeconds <= 0) {
        this.resendOTPDisable = false;
        this.stopTimer();
      }
    }, 1000);
  }

  private stopTimer(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  closeEditForgot(event) {
    this.otpForm.reset();
    this.otpPopClose.emit();
  }

  resendPassword(event) {
    this.startTimer();
    let input;
    let otpEmail;
    let otpPhone;
    const userName = this.email;
    if (userName.match(AppSettings.EMAIL_PATTERN)) {
      otpEmail = userName;
      input = {
        email: userName,
        tenantId: AppSettings.TENANT
      };
    } else if (userName.match(AppSettings.PHONE_PATTERN)) {
      otpPhone = userName;
      input = {
        phoneNum: userName,
        tenantId: AppSettings.TENANT
      };
    } else {
      input = {
        username: userName,
        tenantId: AppSettings.TENANT
      };
    }
    this.commonServices.resendOtp(this.param, JSON.stringify(input)).subscribe(results => {
      // this.dispalyMessage(results.general[0].message, 'success');
      this.commonBindingDataService.showMessage('Success', results.general[0].message);

    }, (error) => {
      // this.dispalyMessage(error.general[0].message, 'error');
      this.commonBindingDataService.showMessage('Error', error.general[0].message);

    });
  }

  changePassword(event) {
    this.msg = [];
    let input;
    this.resendOTPDisable = true;
    const otpInput = this.otpForm.controls.otpInput.value;
    input = {
      otp: otpInput,
      email: this.email
    };

    this.commonServices.validateOtp(JSON.stringify(input)).subscribe(results => {
      this.otpPopSave.emit(results);
      this.otpForm.reset();
    }, (error) => {
      this.commonBindingDataService.showMessage('Error', error.general[0].message);
      this.otpForm.reset();
      // this.dispalyMessage(error.general[0].message, 'error');
      this.resendOTPDisable = false;
    });
  }

  // dispalyMessage(message, msgType) {
  //   this.msg = [];
  //   this.msg.push({
  //     severity: msgType,
  //     summary: msgType,
  //     detail: message
  //   });
  // }

}
